import { useEffect } from 'react';
import type { UseFormReturn } from 'react-hook-form';
import FieldSelect from '/@/components/recommendation-create/bayer/fields-step';
import type { CropProtectionForm } from '/@/types/crop-protection';
import type { Field } from '/@/types/field';

function CropProtectionFieldStep({
    field,
    setField,
    form,
}: {
    field: Field | undefined;
    setField: (field: Field | undefined) => void;
    form: UseFormReturn<CropProtectionForm>;
}) {
    useEffect(() => {
        form.reset({
            fieldId: field?.id,
            crop: '',
            plantingDate: '',
            type: '',
            application: '',
            weedType: '',
            weed: '',
            weedSize: '',
            recommendationOption: '',
            diseaseId: '',
            applicationType: '',
            plagueId: '',
        });
    }, [form]);
    return <FieldSelect field={field} setField={setField} />;
}

export default CropProtectionFieldStep;
